<template>
    <div>
        <div class="container section">
            <div v-if="localEnv">
                <button @click="getData()" v-if="localEnv">
                    getData()
                </button>
            </div>
            <title-block headline="<b>Inspiration til, hvor der kan sættes ind for at øge indtjeningen og likviditeten</b>" class="mb-xl" position="center">
                <p slot="text">
                    Vælg et område og se nogle eksempler på, hvordan virksomheden kan øge indtjeningen.
                </p>
            </title-block>
            <div v-if="!loading && textsLoaded === this.identifiers.length">
                <div style="margin-top:-30px;height:30px;display:flex;justify-content:center;align-items:center;margin-bottom:30px;font-weight:bold;">
                    <span v-if="selectedMenuItem" style="cursor:pointer;" @click="selectedMenuItem = null;selectedBox = null"><i class="far fa-fw fa-arrow-left"></i> Tilbage til oversigt</span>
                </div>
                <div style="text-align:center;margin-bottom:30px;">
                    Alle beregninger er baseret på de seneste 12 hele måneders resultater
                    ({{ data.from | moment('DD/MM/YYYY') }} - {{ data.to | moment('DD/MM/YYYY') }})
                </div>
                <div class="flex" v-show="selectedMenuItem">
                    <div class="flex-item">
                        <div class="headline ss" @click="selectMenuItem('economy')" :class="{'selected': selectedMenuItem === 'economy'}">
                            <span>Økonomi</span>
                            <!--<i class="far fa-fw fa-arrow-down" v-if="selectedMenuItem === 'economy'"></i>
                            <i class="far fa-fw fa-arrow-right" v-else></i>-->
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline ss" @click="selectMenuItem('customers')" :class="{'selected': selectedMenuItem === 'customers'}">
                            <span>Kunder</span>
                            <!--<i class="far fa-fw fa-arrow-down" v-if="selectedMenuItem === 'customers'"></i>
                            <i class="far fa-fw fa-arrow-right" v-else></i>-->
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline ss" @click="selectMenuItem('projects')" :class="{'selected': selectedMenuItem === 'projects'}">
                            <span>Opgaver</span>
                            <!--<i class="far fa-fw fa-arrow-down" v-if="selectedMenuItem === 'projects'"></i>
                            <i class="far fa-fw fa-arrow-right" v-else></i>-->
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline ss" @click="selectMenuItem('employees')" :class="{'selected': selectedMenuItem === 'employees'}">
                            <span>Medarbejdere</span>
                            <!--<i class="far fa-fw fa-arrow-down" v-if="selectedMenuItem === 'employees'"></i>
                            <i class="far fa-fw fa-arrow-right" v-else></i>-->
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline ss" @click="selectMenuItem('potential')" :class="{'selected': selectedMenuItem === 'potential'}">
                            <span>Potentiale</span>
                            <!--<i class="far fa-fw fa-arrow-down" v-if="selectedMenuItem === 'potential'"></i>
                            <i class="far fa-fw fa-arrow-right" v-else></i>-->
                        </div>
                    </div>
                </div>
                <!-- AI Indsigt -->
                <div class="ai-insight-box" v-if="!selectedMenuItem">
                    <div class="ai-insight-header">
                        <span><i class="fas fa-lightbulb"></i> Dagens indsigt</span>
                        <div class="ai-insight-actions">
                            <span class="ai-insight-date" v-if="insight">{{ insight.generated_at | moment('DD/MM/YYYY HH:mm') }}</span>
                            <span class="ai-insight-history" v-if="showHistory" @click="showHistory = false">Skjul historik</span>
                            <span class="ai-insight-history" v-else-if="insightHistory.length > 0" @click="loadHistory">Vis historik</span>
                            <span class="ai-insight-regenerate" v-if="isSuperAdmin" @click="regenerateInsight">
                                <i class="fas fa-sync-alt" :class="{'fa-spin': insightLoading}"></i> Ny indsigt
                            </span>
                        </div>
                    </div>
                    <div class="ai-insight-content" v-if="insightLoading && !insight">
                        <i class="fas fa-spinner fa-spin"></i> Genererer indsigt...
                    </div>
                    <div class="ai-insight-content" v-else-if="insight" v-html="insight.insight">
                    </div>
                    <div class="ai-insight-content ai-insight-empty" v-else>
                        Ingen indsigt tilgængelig endnu.
                    </div>
                    <div class="ai-insight-footer" v-if="insight">
                        <i class="fas fa-robot"></i> Genereret af AI baseret på jeres data. Indsigten er et forslag og bør altid vurderes i kontekst af jeres virksomhed.
                    </div>
                    <div class="ai-insight-history-list" v-if="showHistory && insightHistory.length > 0">
                        <div class="ai-insight-history-item" v-for="(item, index) in insightHistory" :key="index">
                            <span class="ai-insight-history-date">{{ item.generated_at | moment('DD/MM/YYYY') }}</span>
                            <div v-html="item.insight"></div>
                        </div>
                    </div>
                </div>

                <div class="flex" v-if="!selectedMenuItem">
                    <div class="flex-item">
                        <div class="headline" @click="selectMenuItem('economy')" :class="{'selected': selectedMenuItem === 'economy'}">
                            <span>Økonomi</span>
                        </div>
                        <div class="box" @click="selectBox('economy', 'projects')">
                            <div class="text">
                                {{ texts.economy.projects.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ totalOpenValue | currency }}
                            </div>
                        </div>
                        <div class="box" @click="selectBox('economy', 'aconto')">
                            <div class="text">
                                {{ texts.economy.aconto.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ data.economy.aconto.value | currency }}
                            </div>
                        </div>
                        <div class="box" @click="selectBox('economy', 'reminders')">
                            <div class="text">
                                {{ texts.economy.reminders.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ data.economy.reminders.value | currency }}
                            </div>
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline" @click="selectMenuItem('customers')" :class="{'selected': selectedMenuItem === 'customers'}">
                            <span>Kunder</span>
                        </div>
                        <div class="box" @click="selectBox('customers', 'makingMoney')">
                            <div class="text">
                                {{ texts.customers.makingMoney.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ customersMakingMoneyRange ? customersMakingMoneyRange[0] : 0 | currency }} til {{ customersMakingMoneyRange ? customersMakingMoneyRange[1] : 0 | currency }}
                            </div>
                        </div>
                        <div class="box" @click="selectBox('customers', 'smallAndBig')">
                            <div class="text">
                                {{ texts.customers.smallAndBig.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ smallAndBigRange[0].coverage_per_hour | currency }}
                                <span>Omsætning {{ smallAndBigRange[0].name }}</span>
                            </div>
                            <div class="number">
                                {{ smallAndBigRange[1].coverage_per_hour | currency }}
                                <span>Omsætning {{ smallAndBigRange[1].name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline" @click="selectMenuItem('projects')" :class="{'selected': selectedMenuItem === 'projects'}">
                            <span>Opgaver</span>
                        </div>
                        <div class="box" @click="selectBox('projects', 'rightProjects')">
                            <div class="text">
                                {{ texts.projects.rightProjects.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ projectsRightProjectsRange[0] | currency }} til
                                {{ projectsRightProjectsRange[1] | currency }}
                            </div>
                        </div>
                        <div class="box" @click="selectBox('projects', 'mostImportant')">
                            <div class="text">
                                {{ texts.projects.mostImportantFirst.tekstPOverblik }}
                            </div>
                            <div class="number">
                                <span style="font-weight:bold;">{{ projectsMostImportantRange[0].name }}
                                    <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[0].coverage_per_hour_change > 0">&uarr; {{ projectsMostImportantRange[0].coverage_per_hour_change | currency }}</p>
                                    <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[0].coverage_per_hour_change) | currency }}</p>
                                </span>
                            </div>
                            <div class="number">
                                <span style="font-weight:bold;" v-if="projectsMostImportantRange.length > 1">{{ projectsMostImportantRange[1].name }}
                                    <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[1].coverage_per_hour_change > 0">&uarr; {{ projectsMostImportantRange[1].coverage_per_hour_change | currency }}</p>
                                    <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[1].coverage_per_hour_change) | currency }}</p>
                                </span>
                            </div>
                        </div>
                        <div class="box" @click="selectBox('projects', 'mostImportant')">
                            <div class="text">
                                {{ texts.projects.mostImportantSecond.tekstPOverblik }}
                            </div>
                            <div class="number">
                                <span style="font-weight:bold;">{{ projectsMostImportantRange[0].name }}
                                    <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[0].coverage_change > 0">&uarr; {{ projectsMostImportantRange[0].coverage_change | currency }}</p>
                                    <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[0].coverage_change) | currency }}</p>
                                </span>
                            </div>
                            <div class="number">
                                <span style="font-weight:bold;" v-if="projectsMostImportantRange.length > 1">{{ projectsMostImportantRange[1].name }}
                                    <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[1].coverage_change > 0">&uarr; {{ projectsMostImportantRange[1].coverage_change | currency }}</p>
                                    <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[1].coverage_change) | currency }}</p>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline" @click="selectMenuItem('employees')" :class="{'selected': selectedMenuItem === 'employees'}">
                            <span>Medarbejdere</span>
                        </div>
                        <div class="box" @click="selectBox('employees', 'moreTime')">
                            <div class="text">
                                {{ texts.employees.moreTime.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ data.employees.more_time.possible_revenue_increase | currency }}
                                <span>Kundetid i dag: {{ data.employees.more_time.percentage_with_customers | number }}%</span>
                            </div>
                        </div>
                        <div class="box" @click="selectBox('employees', 'lessSickness')">
                            <div class="text">
                                {{ texts.employees.lessSickness.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ data.employees.less_sickness.possible_revenue_increase | currency }}
                                <span>Sygefravær i dag: {{ data.employees.less_sickness.percentage | number }}%</span>
                            </div>
                        </div>
                        <div class="box" @click="selectBox('employees', 'rightPeople')">
                            <div class="text">
                                {{ texts.employees.rightPeople.tekstPOverblik }}
                            </div>
                            <div class="number">
                                {{ employeesRightPeoplePossibleRevenue | currency }}
                            </div>
                        </div>
                    </div>
                    <div class="flex-item">
                        <div class="headline" @click="selectMenuItem('potential')" :class="{'selected': selectedMenuItem === 'potential'}">
                            <span>Potentiale</span>
                        </div>
                        <div class="box">
                            <div class="text" v-html="texts.potential.tekstPOverblik">
                                {{ texts.potential.tekstPOverblik }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:15px;padding:15px;">
                    <possible-efforts-economy v-show="selectedMenuItem === 'economy'"
                        :selectedBox="selectedBox"
                        :data="data.economy"
                        :totalOpenValue="totalOpenValue"
                        :totalAcontoValue="totalAcontoValue"
                        :totalRemindersValue="totalRemindersValue"
                        :texts="texts.economy"
                    ></possible-efforts-economy>
                    <possible-efforts-customers v-show="selectedMenuItem === 'customers'"
                        :selectedBox="selectedBox"
                        :data="data.customers"
                        :customersMakingMoneyRange="customersMakingMoneyRange"
                        :smallAndBigRange="smallAndBigRange"
                        :texts="texts.customers"
                    ></possible-efforts-customers>
                    <possible-efforts-projects v-show="selectedMenuItem === 'projects'"
                        :selectedBox="selectedBox"
                        :data="data.projects"
                        :projectsRightProjectsRange="projectsRightProjectsRange"
                        :projectsMostImportantRange="projectsMostImportantRange"
                        :texts="texts.projects"
                    ></possible-efforts-projects>
                    <possible-efforts-employees v-show="selectedMenuItem === 'employees'"
                        :selectedBox="selectedBox"
                        :data="data.employees"
                        :employeesRightPeoplePossibleRevenue="employeesRightPeoplePossibleRevenue"
                        :projects="data.projects"
                        :texts="texts.employees"
                    ></possible-efforts-employees>
                </div>
            </div>
            <box-loading v-else />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ai-insight-box {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 50px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    max-width: 800px;
    border-left: 4px solid #b29b81;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

    .ai-insight-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 20px;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        font-weight: bold;
        color: #172b43;

        .fa-lightbulb {
            color: #b29b81;
            margin-right: 6px;
        }
    }

    .ai-insight-actions {
        display: flex;
        align-items: center;
        gap: 15px;
        font-weight: normal;
    }

    .ai-insight-date {
        font-size: 12px;
        color: #999;
    }

    .ai-insight-history {
        font-size: 12px;
        color: #b29b81;
        cursor: pointer;
        &:hover { text-decoration: underline; }
    }

    .ai-insight-regenerate {
        font-size: 12px;
        color: #b29b81;
        cursor: pointer;
        padding: 4px 10px;
        border: 1px solid #b29b81;
        border-radius: 4px;
        transition: 0.3s ease all;

        &:hover {
            background: #b29b81;
            color: #fff;
        }
    }

    .ai-insight-content {
        padding: 20px;
        font-size: 14px;
        line-height: 1.6;
        color: #333;

        .insight-summary {
            font-size: 15px;
            margin-bottom: 8px;
        }

        .insight-detail {
            color: #555;
            margin-bottom: 12px;
        }

        .insight-gain {
            background: #f0f7f0;
            padding: 8px 12px;
            border-radius: 4px;
            color: #2e7d32;
            font-size: 14px;
        }

        p { margin: 0 0 8px 0; }
        p:last-child { margin-bottom: 0; }
    }

    .ai-insight-footer {
        padding: 10px 20px;
        font-size: 11px;
        color: #999;
        border-top: 1px solid #eee;

        .fa-robot {
            margin-right: 4px;
        }
    }

    .ai-insight-empty {
        color: #999;
        font-style: italic;
    }

    .ai-insight-history-list {
        border-top: 1px solid #eee;
        padding: 15px 20px;

        .ai-insight-history-item {
            padding: 10px 0;
            font-size: 13px;
            color: #666;
            border-bottom: 1px solid #f5f5f5;
            line-height: 1.5;

            &:last-child { border-bottom: none; }
        }

        .ai-insight-history-date {
            font-weight: bold;
            color: #172b43;
            margin-right: 8px;
        }
    }
}

.flex {
    display: flex;

    .flex-item {
        flex: 0 0 20%;
        padding: 0 15px;

        .headline {
            font-size: 16px !important;
            padding: 15px;
            background: #172b43;
            color: #fff;
            // border-radius: 4px;
            cursor: pointer;
            transition: 0.3s ease all;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px 4px 0px 0px;

            &:hover:not(.ss) {
                background: #03a9f4;
                color: #fff;
            }

            &.ss {
                background: #fff;
                color: #172b43;
                border-radius: 4px !important;
            }

            &.ss:hover {
                background: #172b43;
                color: #fff;
            }

            &.selected {
                background: #172b43;
                color: #fff;
            }
        }

        .box {
            border-top: 2px solid #eee;
            // margin-top: 30px;
            background: #fff;
            // box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
            padding: 15px;
            // border-radius: 4px;
            font-size: 14px;
            transition: 0.3s ease all;
            cursor: pointer;

            &:hover {
                background: #172b43;
                color: #fff;
            }

            .text {

            }

            .number {
                font-weight: bold;
                margin-top: 5px;
                font-size: 20px;

                span {
                    display: block;
                    font-size: 14px;
                    font-weight: normal;
                }
            }

            &:last-of-type {
                border-radius: 0px 0px 4px 4px;
            }
        }
    }
}
</style>

<style lang="scss">
.possible-efforts-sub-menu {

    .switcher {
        display: flex;
        margin-bottom: 30px;

        .item {
            margin-right: 30px;
            padding: 10px 15px;
            background: #fff;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            transition: 0.3s ease all;
            cursor: pointer;
            font-size: 14px;

            &:hover:not(.selected) {
                background: #ddd;
            }

            &.selected {
                background: #172b43;
                color: #fff;
            }
        }
    }

    .lg {
        margin-top: 40px;
        font-size: 16px;
        font-weight: bold;
    }

    .sub {
        margin: 10px 0px 20px 0px;
        font-size: 14px;
    }

    .table {
        margin-top: 15px;
        min-height: 400px;
        background: #fff;
        border: 4px dashed #ccc;
        border-radius: 4px;
        
        &:not(.white) {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
.foot {
    margin-top: 30px;
    display: flex;

    &:not(.left) {
        justify-content: flex-end;
    }

    .button {
        display: inline-block;
        cursor: pointer;
        padding: 8px 15px;
        border-radius: 4px;
        background: #fff;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
        transition: 0.3s ease all;

        &:hover {
            background: #172b43;
            color: #fff;
        }
    }
}
</style>

<script>
import * as possibleEffortsService from '@/services/possibleEffortsService'
import * as dailyInsightService from '@/services/dailyInsightService'

export default {
    data () {
        return {
            selectedMenuItem: null,
            selectedBox: null,
            loading: true,
            data: null,
            insight: null,
            insightLoading: false,
            insightHistory: [],
            showHistory: false,
            identifiers: [
                'economy.projects',
                'economy.aconto',
                'economy.reminders',
                'customers.makingMoney',
                'customers.smallAndBig',
                'projects.rightProjects',
                'projects.mostImportantFirst',
                'projects.mostImportantSecond',
                'employees.moreTime',
                'employees.lessSickness',
                'employees.rightPeople',
                'potential'
            ],
            textsLoaded: 0,
            texts: {
                economy: {
                    projects: {
                        tekstPOverblik: 'Her er de muligvis 10 største opgaver, der ikke er sat i gang, med et muligt dækningsbidrag på',
                        boksTekst: 'Sæt opgaver i gang',
                        tykTekst1: 'Den mulige indtjening på opgaver, der ikke er sat i gang, er ca.',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du værdien af de 10 største opgaver, der ikke er sat i gang endnu:'
                    },
                    aconto: {
                        tekstPOverblik: 'Aconto fakturering minimerer risikoen for at tabe penge og forbedrer likviditeten. Salgsværdien af igangværende arbejder er ca.',
                        boksTekst: 'Aconto betalinger',
                        tykTekst1: 'Salgsværdien af igangværende arbejder er ca.',
                        tykTekst2: null,
                        tyndTekst1: 'Du sikrer dine tilgodehavender og likviditet ved at aconto fakturere mest muligt.<br>Her ser du værdien af de 10 største igangværende arbejder. Vurder om der er kunder, som bør acontofaktureres:'
                    },
                    reminders: {
                        tekstPOverblik: 'Der er fakturaer med overskreden betaling for i alt',
                        boksTekst: 'Start rykkerprocessen',
                        tykTekst1: 'Der er fakturaer med overskreden betaling for i alt',
                        tykTekst2: null,
                        tyndTekst1: 'Tag tyren ved hornene og tal med kunden om den manglende betaling mens I begge kan huske, hvad der skal betales for. Sandsynligheden for at få pengene øges betydeligt ved at sætte ind hurtigt. Her ser du de 10 største ubetalte fakturaer:'
                    }
                },
                customers: {
                    makingMoney: {
                        tekstPOverblik: 'Indtjeningen pr. time på de 10 største kunder spænder fra',
                        boksTekst: 'Er de største kunder lønsomme?',
                        tykTekst1: 'Indtjeningen på de 10 største kunder spænder fra',
                        tykTekst2: null,
                        tyndTekst1: 'Vurder om priserne skal hæves for bestemte kunder, eller I måske skal stoppe med at arbejde for dem. Er det muligt at finde nye kunder, der ligner de lønsomme? Her er de 10 største kunder målt på indtjeningen pr. time:'
                    },
                    smallAndBig: {
                        tekstPOverblik: 'På de 2 grupper af kunder med størst omsætning tjenes der pr. time',
                        boksTekst: 'Kan vi tjene penge på både små og store kunder?',
                        tykTekst1: 'På de 2 grupper af kunder med den største indtjening tjenes der henholdsvis',
                        tykTekst2: null,
                        tyndTekst1: 'Se forskellene på indtjeningen i de forskellige grupper og vurder om det er karakteren af opgaven, der gør indtjeningen forskellig, eller om priserne kan justeres. Måske er der opgaver, som kræver mere forberedelse Vurder også, hvad skal der til for at øge indtjeningen på de grupper af kunder, hvor indtjeningen er lavere.'
                    }
                },
                projects: {
                    rightProjects: {
                        tekstPOverblik: 'Indtjeningen på de 10 største opgavetyper spænder fra',
                        boksTekst: 'Arbejdes der med de rigtige opgaver?',
                        tykTekst1: 'Indtjeningen på de 10 største opgavetyper spænder fra',
                        tykTekst2: null,
                        tyndTekst1: 'Se hvor I bruger jeres tid og om indtjeningen pr. time er tilfredsstillende. Indtjeningen kan ofte øges væsentligt med små justeringer af priserne. Måske er der også opgavetyper, I skal træne mere i eller stoppe med at tilbyde. Vurder også, om I har de rigtige opgavetyper i ordrestyringssystemet, så oversigten bliver bedst mulig at handle efter.'
                    },
                    mostImportantFirst: {
                        tekstPOverblik: 'Udviklingen i dækningsbidraget pr. time på de 2 største opgavetyper er',
                        boksTekst: 'Går indtjeningen frem eller tilbage på de vigtigste opgavetyper?',
                        tykTekst1: 'Udviklingen i dækningsbidraget pr. time OG i det samlede dækningsbidrag på de 2 største opgavetyper de seneste 12 måneder er:',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du, om dækningsbidraget og indtjeningen pr. time på de vigtigste opgavetyper er gået frem eller tilbage de sidste 6 måneder. Vurder hvad det betyder for virksomheden på sigt, hvis f.eks. det samlede dækningsbidrag stiger, men dækningsbidraget pr. time falder. Er det øget konkurrence, som gør, at virksomheden bør overveje at fokusere på andre opgavetyper?'
                    },
                    mostImportantSecond: {
                        tekstPOverblik: 'Udviklingen i det SAMLEDE dækningsbidrag på de 2 største opgavetyper er',
                        boksTekst: 'Går indtjeningen frem eller tilbage på de vigtigste opgavetyper?',
                        tykTekst1: 'Udviklingen i dækningsbidraget pr. time OG i det samlede dækningsbidrag på de 2 største opgavetyper de seneste 12 måneder er:',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du, om dækningsbidraget og indtjeningen pr. time på de vigtigste opgavetyper er gået frem eller tilbage de sidste 6 måneder. Vurder hvad det betyder for virksomheden på sigt, hvis f.eks. det samlede dækningsbidrag stiger, men dækningsbidraget pr. time falder. Er det øget konkurrence, som gør, at virksomheden bør overveje at fokusere på andre opgavetyper?'
                    }
                },
                employees: {
                    moreTime: {
                        tekstPOverblik: 'Hvis den tid svendene er hos kunderne kan øges med 5%, kan indtjeningen stige med',
                        boksTekst: 'Øg svendenes tid hos kunderne',
                        tykTekst1: 'Tid svendene er hos kunderne af den tid, der registreres:',
                        tykTekst2: 'Hvis kundetiden kan øges med 5%, vil indtjeningen stige med',
                        tyndTekst1: 'Det er kun tiden hos kunderne, der kan faktureres. Derfor er det vigtigt, at tiden brugt på administration og andre aktiviteter er mindst mulig. Her kan du se, hvad svendene bruger den disponible tid til og hvor der eventuelt kan hentes mere kundetid.'
                    },
                    lessSickness: {
                        tekstPOverblik: 'Hvis sygefraværet kan sættes ned til 2%, vil indtjeningen stige med',
                        boksTekst: 'Gør sygefraværet mindre',
                        tykTekst1: 'Sygefraværet de seneste 12 måneder er:',
                        tykTekst2: 'Hvis sygefraværet kan sættes ned til 2%, vil indtjeningen stige med',
                        tyndTekst1: 'En svend kan selvfølgelig godt være syg af medicinske grunde, men der kan også være andre faktorer, som f.eks. arbejdsmiljø og usikkerhed over vor bestemte opgavetyper, der giver sygefravær. Her ser du svende med det største sygefravær og hvem der eventuelt skal tales med.'
                    },
                    rightPeople: {
                        tekstPOverblik: 'Hvis dækningsbidraget pr. time på de svende, der indtjener mindre end gennemsnittet af svendene, hæves til gennemsnittet af svendene i dag, vil indtjeningen kunne øges med',
                        boksTekst: 'Sæt de rigtige svende på opgaverne',
                        tykTekst1: 'Hvis dækningsbidraget pr. time på de svende, der indtjener mindre end gennemsnittet, hæves til gennemsnittet i dag, vil indtjeningen øges med',
                        tykTekst2: null,
                        tyndTekst1: 'Svendene er ikke lige gode til alle opgaver. Der kan øge indtjeningen betydeligt, at sætte svendene på de opgavetyper, de er bedst til, når det er praktisk muligt. Her ser du, hvilke svende, der indtjener mest pr. time på den opgavetype, I bruger mest tid på:'
                    }
                },
                potential: {
                    tekstPOverblik: 'Her kan I hurtigt og let beregne, hvad der er af mulig øget indtjening, ved at skrue på blandt andet<ul><li>&bull;&nbsp;antal timer hos kunden</li><li>&bull;&nbsp;prisen på hver enkelt opgavetype justeres</li></ul>',
                    boksTekst: null,
                    tykTekst1: null,
                    tykTekst2: null,
                    tyndTekst1: null
                }
            }
        }
    },
    mounted () {
        this.identifiers.forEach((identifier) => {
            this.getContentfulData(identifier)
        })
        this.getData()
        this.getInsight()
    },
    methods: {
        selectMenuItem (menuItem) {
            this.selectedBox = null
            if (menuItem === 'potential') {
                this.$router.push({name: 'Potential'})
                return
            }
            this.selectedMenuItem = menuItem
        },
        selectBox (menuItem, box) {
            this.selectedBox = box
            this.selectedMenuItem = menuItem
        },
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            possibleEffortsService.all(params, (response) => {
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        getInsight () {
            dailyInsightService.get((response) => {
                this.insight = response.data
            }, () => {})
        },
        regenerateInsight () {
            this.insightLoading = true
            dailyInsightService.regenerate((response) => {
                this.insight = response.data
                this.insightLoading = false
                this.showHistory = false
                this.insightHistory = []
            }, () => {
                this.insightLoading = false
            })
        },
        loadHistory () {
            if (this.insightHistory.length > 0) {
                this.showHistory = true
                return
            }
            dailyInsightService.history((response) => {
                this.insightHistory = response.data
                this.showHistory = true
            }, () => {})
        },
        getContentfulData (identifier, model) {
            const contentful = require('contentful')
            const client = contentful.createClient({
            // This is the space ID. A space is like a project folder in Contentful terms
            space: '3h0kg5qa88is',
            // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
            accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            })
            // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
            client
            .getEntries({
                content_type: 'muligeIndsatser',
                'fields.identifier[in]': identifier
            })
            // .getEntry('4SzlILGMZwweEFr9myvbxT')
            .then(entries => {
                console.log('entries', entries)
                // Economy
                if (identifier === 'economy.projects') { this.texts.economy.projects = entries.items[0].fields }
                if (identifier === 'economy.aconto') { this.texts.economy.aconto = entries.items[0].fields }
                if (identifier === 'economy.reminders') { this.texts.economy.reminders = entries.items[0].fields }

                // Customers
                if (identifier === 'customers.makingMoney') { this.texts.customers.makingMoney = entries.items[0].fields }
                if (identifier === 'customers.smallAndBig') { this.texts.customers.smallAndBig = entries.items[0].fields }

                // Projects
                if (identifier === 'projects.rightProjects') { this.texts.projects.rightProjects = entries.items[0].fields }
                if (identifier === 'projects.mostImportantFirst') { this.texts.projects.mostImportantFirst = entries.items[0].fields }
                if (identifier === 'projects.mostImportantSecond') { this.texts.projects.mostImportantSecond = entries.items[0].fields }

                // Employees
                if (identifier === 'employees.moreTime') { this.texts.employees.moreTime = entries.items[0].fields }
                if (identifier === 'employees.lessSickness') { this.texts.employees.lessSickness = entries.items[0].fields }
                if (identifier === 'employees.rightPeople') { this.texts.employees.rightPeople = entries.items[0].fields }

                // Potential
                if (identifier === 'potential') { this.texts.potential = entries.items[0].fields }

                this.textsLoaded++
            })
            .catch(err => console.log(err))
        }
    },
    computed: {
        isSuperAdmin () {
            try {
                return this.$auth.user().roles[0].name === 'super-admin'
            } catch (e) {
                return false
            }
        },
        localEnv () {
            if (process.env.NODE_ENV === 'development') {
                return true
            }
            return false
        },
        totalOpenValue () {
            let total = 0
            if (this.data) {
                this.data.economy.projects.table.forEach((project) => {
                    total += Number(project.expected_coverage)
                })
            }
            return total
        },
        totalAcontoValue () {
            let total = 0
            if (this.data) {
                this.data.economy.aconto.table.forEach((project) => {
                    total += Number(project.value_with_avg_cp)
                })
            }
            return total
        },
        totalRemindersValue () {
            let total = 0
            if (this.data) {
                this.data.economy.reminders.table.forEach((invoice) => {
                    total += Number(invoice.amount)
                })
            }
            return total
        },
        customersMakingMoneyRange () {
            let arr = []
            if (this.data) {
                this.data.customers.making_money.table.forEach((customer, index) => {
                    arr.push(Number(customer.coverage_per_hour))
                })
            }
            arr.sort(function (a, b) {
                return a - b
            })
            return [arr[0], arr[arr.length - 1]]
        },
        smallAndBigRange () {
            if (this.data) {
                let ranges = this.data.customers.small_and_big.table
                return [ranges[0], ranges[1]]
            }
            return [0, 0]
        },
        projectsRightProjectsRange () {
            let arr = []
            if (this.data) {
                this.data.projects.right_projects.table.forEach((project, index) => {
                    arr.push(Number(project.coverage_per_hour))
                })
            }
            arr.sort(function (a, b) {
                return a - b
            })
            return [arr[0], arr[arr.length - 1]]
        },
        projectsMostImportantRange () {
            let arr = []
            if (this.data) {
                let first = this.data.projects.most_important.table.values[0]
                let second = this.data.projects.most_important.table.values[1]
                if (first) {
                    arr.push({
                        name: first.name ? first.name : '-',
                        coverage_first: first.coverage.first,
                        coverage_last: first.coverage.last,
                        coverage_change: first.coverage.last - first.coverage.first,
                        coverage_per_hour_first: first.coverage_per_hour.first,
                        coverage_per_hour_last: first.coverage_per_hour.last,
                        coverage_per_hour_change: first.coverage_per_hour.last - first.coverage_per_hour.first
                    })
                }
                if (second) {
                    arr.push({
                        name: second.name ? second.name : '-',
                        coverage_first: second.coverage.first,
                        coverage_last: second.coverage.last,
                        coverage_change: second.coverage.last - second.coverage.first,
                        coverage_per_hour_first: second.coverage_per_hour.first,
                        coverage_per_hour_last: second.coverage_per_hour.last,
                        coverage_per_hour_change: second.coverage_per_hour.last - second.coverage_per_hour.first
                    })
                }
            }
            return arr
        },
        employeesRightPeoplePossibleRevenue () {
            let total = 0
            if (this.data) {
                let avg = this.data.employees.right_people.avg_coverage_per_hour
                this.data.employees.right_people.table.forEach((employee) => {
                    if (employee.coverage_per_hour < avg) {
                        total += (avg - employee.coverage_per_hour) * employee.total_hours
                    }
                })
                return total
            }
            return total
        }
    },
    components: {
        'possible-efforts-economy': require('../components/elements/PossibleEfforts/economy.vue'),
        'possible-efforts-customers': require('../components/elements/PossibleEfforts/customers.vue'),
        'possible-efforts-projects': require('../components/elements/PossibleEfforts/projects.vue'),
        'possible-efforts-employees': require('../components/elements/PossibleEfforts/employees.vue')
    }
}
</script>



// WEBPACK FOOTER //
// possibleEfforts.vue?40d0420e